import React, { useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import { loginUser } from "~/shared/auth-utils";
import Page from "~/shared/Page";
import TextInput from "~/shared/form/TextInput";
import ControlledForm from "~/shared/form/ControlledForm";
import FormResponse from "~/shared/form/FormResponse";
import { useForm } from "react-hook-form";
import usePublicNavbar from "./use-public-navbar";
import FormButton from "~/shared/form/FormButton";
import useModal from "~/shared/UseModal";
import { useHistory } from "react-router-dom";

/**
 * @param {Object} props
 * @param {"ADMIN" | "STAFF" | "FAMILY"} props.portalType
 */
export default function LoginPortal({ portalType }) {
    const { search } = useLocation();
    const formHook = useForm();
    const { ModalDialog, showAlert } = useModal();
    const history = useHistory();

    useEffect(() => {
        if (search === "?expired") {
            formHook.setError("root.formResponse", { type: "error", message: "Login expired. Please log in again." });
        } else if (search === "?idle") {
            formHook.setError("root.formResponse", { type: "error", message: "You have automatically been logged out due to inactivity." });
        }
    }, []);

    async function onSuccess(response) {
        if (response.code === "mfa-required") {
            showAlert("MFA Required", "To protect your account, an email with a temporary link to login has been sent to your email address. Please click the link to login.");
            formHook.reset({ email: "", password: "" });
        } else {
            loginUser(response.token);
            history.push("/");
        }
    }

    return (
        <Page title={`${portalType[0] + portalType.substring(1).toLowerCase()} Portal`} className={`${portalType.toLowerCase()}-bg`} showTranslator={portalType === "FAMILY"} navBar={usePublicNavbar(portalType !== "ADMIN")}>
            <div className="flex flex-col flex-1">
                <div className={`portal-container p-8 py-6 max-w-md ${portalType === "FAMILY" ? "mb-0" : ""}`}>
                    <h2 className="text-2xl font-semibold text-left mb-5">Login</h2>
                    <ControlledForm className="flex flex-col" hook={formHook} post={`auth/login/${portalType.toLowerCase()}`} onSuccess={onSuccess} noAsterisk>
                        <div className="flex flex-col gap-4">
                            <TextInput label="Email" id="email" placeholder="Enter email address" preset="email" required />
                            <TextInput label="Password" id="password" placeholder="Enter password" preset="password" required />
                        </div>
                        <Link to={{ pathname: "/reset-password", state: { fromPortal: portalType } }} className="red-link ml-auto mt-1">Forgot password?</Link>
                        <FormResponse className="mt-4 mb-0" />
                        <FormButton className="mx-auto mt-6" submit>Log in</FormButton>
                    </ControlledForm>
                </div>
                {portalType === "FAMILY" && <div className="portal-container p-8 py-6 max-w-md mt-8 bg-neutral-200">
                    Don't have an account? <Link to="/register" className="red-link">Register now.</Link>
                </div>}
            </div>
        </Page>
    );
}
